/**
 * @fileoverview Page header component.
 * @summary Reusable header component for pages with title and optional subtitle.
 *
 * @package KaraoNow
 * @module apps/front/src/components/PageHeader
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { type ReactNode } from 'react'

interface PageHeaderProps {
  title: string | ReactNode
  subtitle?: string | ReactNode
  className?: string
  children?: ReactNode
}

/**
 * @summary Page header component.
 * @param {PageHeaderProps} props - Component props.
 * @returns {React.ReactElement} Page header.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export default function PageHeader({
  title,
  subtitle,
  className = 'mb-2',
  children,
}: PageHeaderProps) {
  return (
    <div className={`flex flex-col items-center justify-between ${className}`}>
      <div className="mb-4 text-center w-full">
        <h2 className="card-title text-gradient">{title}</h2>
        {subtitle && <p className="mt-2 text-lg text-(--color-text-primary) bg-white/40">{subtitle}</p>}
      </div>
      {children}
    </div>
  )
}

